export const brand = [
  {
    "id": "1",
    "name": "Honda",
    "models":['Amaze','City','Brio','Jazz','Civic','Accord']
  },
  {
    "id": "2",
    "name": "Hyundai",
    "models":[ 'Santro',' Grand i10 Nios', 'i20', 'i20 N Line',' Aura', 'Verna', 'Venue',  'Creta',  'Alcazar', 'Tucson',  'Kona']
  },
  {
    "id": "3",
    "name": "Maruti Suzuki",
     'models':[ 'Alto', 'Wagon R', 'Baleno', 'Swift', 'Dzire', 'S-Presso', 'Alto', 'Ignis', 'Ciaz',]
  },
  {
    "id": "4",
    "name": "Tata",
    'models':['Nexon', 'Punch', 'Harrier', 'Safari', 'Altroz', 'Tiago',' Tigor']
  },
  {
    "id": "5",
    "name": "Toyota",
    'models':['Innova Crysta', 'Urban Cruiser', 'Fortuner', 'Glanza',' Camry',' Hyryder',' Vellfire',  'Hilux']
  },
  
  {
    "id": "6",
    "name": "Mahindra",
    'models':['Thar', 'Scorpio N', 'Bolero',' XUV 700',' XUV 300']
  },
 
  {
    "id": "7",
    "name": "Renault",
    'models':[ 'Kwid', 'Triber', 'Kiger', 'Duster']
  },
 
  {
    "id": "8",
    "name": "Volkswagen",
    'models':['Virtus', 'Taigun', 'Tiguan']
  },
 
]
